import * as React from 'react'
import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Stack from '@eversports/klimt-primitives/Stack'

const SectionCard = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <Stack
      gap={3}
      sx={{
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'mediumgray',
        borderRadius: { xs: 0, md: 1 },
        boxShadow: boxShadows.default,
        padding: 4,
      }}
    >
      {children}
    </Stack>
  )
}

export default SectionCard
